<template>
  <b-tab title="My learning units" lazy>
    <div slot="title">
      <span class="font-size-md active span__basic-info-tab">Basic info</span>
      <div class="divider" />
    </div>

    <BaseBasicInfo
      :editable="editable"
      :disabled="disabled"
      :mode="mode"
      :has-method-component="hasMethodComponent"
    ></BaseBasicInfo>
  </b-tab>
</template>

<script>
import BaseBasicInfo from './components/BaseBasicInfo';

export default {
  components: {
    BaseBasicInfo
  },
  props: {
    mode: {
      type: String,
      default: 'instructor'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Object,
      default: () => {
        return {
          generalInfo: false,
          method: false,
          learning: false
        };
      }
    },
    hasMethodComponent: {
      type: Boolean,
      default: false
    }
  }
};
</script>
